import { createApp } from "vue";
import ArchiveSearch from "./archive-search.vue";

function initArchiveSearch() {
    const el = document.getElementById("archiveSearch");

    if (!el) return;

    const model = JSON.parse(el.dataset.model || "[]");

    createApp(ArchiveSearch, {
        model,
        fullTextSearchUrl: el.dataset.fullTextSearchUrl,
        detailPageUrl: el.dataset.detailPageUrl
    }).mount(el);
}

document.addEventListener("DOMContentLoaded", initArchiveSearch);